export function stripPriceFromName(name: string): string {
	return name.replace(/\$[\d.,]+\s*/g, '').trim();
}
